<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="fr02-2">
<p class="centerImage"><img alt="image" id="imgaut3" src="images/imgaut3.jpg"/></p>
<p class="caption1">Peter Ivanovich Bagration</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// therussian_fr022.vue?520ce5f2